/**
 * 008-reporting-dashboards T008/T010 — §17's "failed Tally syncs" tile. Shows the API's own
 * `failedCount` (items in `failed`, counted by TallySync), never the wider `unsyncedCount`, which also
 * holds work merely waiting. `null` when the API omits the field — kept as `null`, never coerced to
 * `0` (FR-002). Drills through to the queue filtered to `failed`. Drawn by `StatusCard`.
 */
import { PiTrayDuotone as Inbox } from "react-icons/pi";
import { TileBoundary } from "./TileBoundary";
import { StatusCard, UnreadableStatusCard } from "./StatusCard";

const icon = <Inbox aria-hidden className="size-5" />;

function unreadable(error: unknown) {
  return <UnreadableStatusCard title="Failed Tally syncs" icon={icon} error={error} fallback="The queue could not be read, so this is not zero — it is unknown." />;
}

export function FailedSyncsTile({ resolve }: { resolve: Promise<number | null> }) {
  return (
    <TileBoundary resolve={resolve} errorFallback={unreadable}>
      {(failedCount) => (
        <StatusCard
          title="Failed Tally syncs"
          icon={icon}
          tone={failedCount === null ? "muted" : failedCount > 0 ? "destructive" : "success"}
          value={failedCount === null ? "Not reported" : failedCount}
          word={failedCount === null}
          caption="Records Tally refused, with its own error text on the queue."
          link={{ to: "/integrations/tally/queue?status=failed", label: "Open the failed records" }}
        />
      )}
    </TileBoundary>
  );
}
